const onReady = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
        return;
    }

    callback();
};

const initFormieInputRestrictions = () => {
    const inputs = document.querySelectorAll('.fui-name-field .fui-input');

    if (!inputs.length) {
        return;
    }

    const sanitizeValue = (value) => value.replace(/[^A-Za-z]/g, '');

    inputs.forEach((input) => {
        input.addEventListener('keypress', (event) => {
            const char = String.fromCharCode(event.which || event.keyCode);

            if (!/[A-Za-z]/.test(char)) {
                event.preventDefault();
            }
        });

        const applySanitizedValue = () => {
            input.value = sanitizeValue(input.value);
        };

        input.addEventListener('input', applySanitizedValue);
        input.addEventListener('change', applySanitizedValue);
        input.addEventListener('keyup', applySanitizedValue);
    });
};

export default () => onReady(initFormieInputRestrictions);
